import { render } from "./TheNodeTreeMenu.vue?vue&type=template&id=15dc5b4f"
import script from "./TheNodeTreeMenu.vue?vue&type=script&lang=js"
export * from "./TheNodeTreeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__